import {Navigate, useLocation, useOutlet} from "react-router-dom";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import {replaceDevUrl} from "utils/functions";
import React, {useEffect, useRef} from "react";
import ScrollBar from "../../shared/ui/ScrollBar";
import Container from "@mui/material/Container";
import Sidebar from "../sidebar/Sidebar";
import useMediaQuery from "@mui/material/useMediaQuery";
import {useTheme} from "@mui/material/styles";
import useIsLoggedIn from "../../hooks/useIsLoggedIn";
import Menu from "../sidebar/Menu";

const LayoutPublic = ({bgImage = ""} : {bgImage?: string}) => {
    const isLoggedIn = useIsLoggedIn();
    const outlet = useOutlet();
    const theme = useTheme();
    const isLargeScreen = useMediaQuery(theme.breakpoints.up("lg"));
    const simpleBarRef = useRef(null);
    const location = useLocation();

    useEffect(() => {
        // Scroll to the top whenever the content changes
        if (simpleBarRef.current) {
            // @ts-ignore
            simpleBarRef.current.getScrollElement().scrollTo({ top: 0, behavior: "instant" });
        }
    }, [outlet]);

    if (isLoggedIn) {
        if(location.pathname === "/intrebari-frecvente-brio") {
            return <Navigate to="/intrebari-frecvente" replace/>;
        } else if (location.pathname === "/contact-brio") {
            return <Navigate to="/contact" replace/>;
        } else return <Navigate to="/statistici" replace/>;
    }

    // if (
    //   user &&
    //   user.firstname !== undefined &&
    //   user.firstname !== null &&
    //   user.firstname !== "" &&
    //   user.email_verified === null
    // ) {
    //   return <Navigate to="/verifica-email" replace />;
    // }

    return (
        <Box component="main" className="main" display="flex" alignItems="stretch" sx={{minHeight: "100dvh", padding: {lg: "40px"}}}>
            <Grid
                // display="grid"
                container
                direction="row"
                spacing={0}
                sx={(theme) => ({
                    borderRadius: {xs: 0, lg: theme.spacing(4, 4, 3, 3)},
                    background: bgImage !== "" ? "rgba(0, 40, 155, 0.4) no-repeat center" : "transparent",
                    backgroundImage: bgImage !== "" ? `url(${replaceDevUrl(bgImage)})` : "none",
                    backgroundSize: "cover",
                    backgroundBlendMode: "soft-light",
                    position: "relative",
                    boxShadow: "0px 2px 5px rgba(0,0,0,0.3)"
                })}
            >
                <Grid
                    item
                    xs={12}
                    position="relative"
                    sx={(theme) => ({
                        padding: 0,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        borderRadius: 3,
                        margin: 0,
                    })}
                >
                   <Sidebar layoutPublic={true} bgImage={!!bgImage} />
                </Grid>
                <Grid
                    item
                    xs={12}
                    sx={(theme) => ({
                        border: bgImage ? "none" : {xs: "none", lg: `1px solid ${theme.palette.background.paper}`},
                        borderRadius: theme.spacing(0, 0, 3, 3),
                    })}
                >
                    {isLargeScreen ? (
                        <ScrollBar ref={simpleBarRef} style={{height: "calc(100dvh - 170px)", width: "100%"}} forceVisible="x" autoHide={false} >
                            <Box  display="flex"
                                  flexDirection="column"
                                  justifyContent="space-between"
                                  minHeight="calc(100dvh - 180px)"
                                  width="100%"
                            >
                                <Box
                                    display="flex"
                                    flexDirection="column"
                                    justifyContent={bgImage ? "center" : "flex-start"}
                                    alignContent="center"
                                    width="100%"
                                    minHeight="calc(100dvh - 283px)"
                                    sx={(theme) => ({
                                        padding: {
                                            xs: theme.spacing(3, 0, 0, 0),
                                            lg: theme.spacing(5, 0, 0, 0)
                                        }
                                    })}
                                > <Container maxWidth="xl">{outlet}</Container>
                                </Box>
                                <Box width="100%"
                                    sx={(theme) => ({
                                    padding: theme.spacing(1, 2, 1, 3),
                                    backgroundColor: theme.palette.background.paper,
                                    bottom: "-10px",
                                    position: "relative",
                                    borderRadius: theme.spacing(0, 0, 2.7, 2.7),
                                        marginTop: theme.spacing(5),
                                })}>
                                   <Menu direction="horizontally" />
                                </Box>
                            </Box>
                        </ScrollBar>
                    ) : (
                        <Box  display="flex"
                              flexDirection="column"
                              justifyContent="space-between"
                              minHeight="calc(100dvh - 180px)"
                              width="100%"
                        >
                        <Box
                            display="flex"
                            flexDirection="column"
                            justifyContent={bgImage ? "center" : "flex-start"}
                            alignContent="center"
                            width="100%"
                            sx={(theme) => ({
                                padding: {
                                    xs: theme.spacing(3, 0, 0, 0),
                                    lg: theme.spacing(5, 1, 5, 1)
                                },
                                minHeight: "calc(100dvh - 183px)"
                            })}
                        > <Container maxWidth="xl">{outlet}</Container>

                        </Box>
                            <Box width="100%"
                                 sx={(theme) => ({
                                     padding: theme.spacing(1, 2, 1, 3),
                                     backgroundColor: theme.palette.background.paper,
                                     position: "relative",
                                     marginTop: theme.spacing(5),
                                 })}>
                                <Menu direction="horizontally" />
                            </Box>
                        </Box>
                    )}
                </Grid>
{/*                <Grid*/}
{/*                    item*/}
{/*                    xs={12}*/}
{/*                    position="relative"*/}
{/*                    sx={(theme) => ({*/}
{/*                        padding: 1,*/}
{/*                        display: "flex",*/}
{/*                        flexDirection: "column",*/}
{/*                        justifyContent: "space-between",*/}
{/*                        borderRadius: 3,*/}
{/*                        margin: 0,*/}
{/*                        backgroundColor: "rgba(0, 40, 155, 0.4)",*/}
{/*                    })}*/}
{/*                >*/}
{/*Meniu*/}
{/*                </Grid>*/}
            </Grid>
        </Box>
    );
};

export default LayoutPublic;
